import axios from '@/plugins/axios.js';

export default {
    async fetchAccountUsers({ commit, rootState }) {
        const response = await axios.get('users', {
            params: {
                account_id: rootState.authUser.account.id,
            },
        });

        commit('setUsers', response.data.data);

        return response.data;
    },

    async createUser({ commit }, user) {
        const response = await axios.post('users', user);

        commit('addUser', response.data.data);

        return response.data.data;
    },

    async updateUser({ commit }, user) {
        if (!user.password) {
            delete user.password;
            delete user.password_confirmation;
        }

        const response = await axios.put(`users/${user.id}`, user);

        commit('updateUser', response.data.data);

        return response.data.data;
    },

    async deleteUser({ commit }, user) {
        commit('deleteUser', user);

        return axios.delete(`users/${user.id}`);
    },

    // PHONES

    async fetchAccountPhones({ commit, rootState }) {
        const response = await axios.get('provider-phones', {
            params: {
                account_id: rootState.authUser.account.id,
            },
        });

        commit('setPhones', response.data.data);

        return response.data;
    },

    // ACCOUNTS

    async fetchAccount({ rootState }) {
        const response = await axios.get(`accounts/${rootState.authUser.account.id}`);

        return response.data.data;
    },

    async updateAccount(store, account) {
        return axios.put(`accounts/${account.id}`, {
            address: account.address,
            city: account.city,
            country: account.country,
            name: account.name,
            phone: account.phone,
            postal_code: account.postal_code,
            province: account.province,
            timezone: account.timezone,
        });
    },
};
